import styled from 'styled-components';

const colorMap: Record<string, string> = {
  fair: 'rgba(243, 175, 103, 1)',
  poor: 'rgba(175, 41, 48, 1)',
  good: 'rgba(69, 155, 74, 1)'
};

const Wrapper = styled.div`
  display: flex;
  width: calc(100% + 90px);
  margin-left: -45px;
`;

const BarWrapper = styled.div<{ basis: number }>`
  display: flex;
  flex-direction: column;
  gap: 3.8px;
  align-items: center;
  flex: 1 1 ${props => `${props.basis}%`};
`;

const Bar = styled.div<{ color: string }>`
  height: 2.85px;
  width: 100%;
  background: ${props => props.color};
`;

const Percent = styled.div<{ color: string }>`
  color: ${props => props.color};
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
`;

type GradePercent = {
  type: string;
  value: number;
};

type Props = {
  gradePercents: GradePercent[];
};

export const GradeUIBar = ({ gradePercents }: Props) => {
  return (
    <Wrapper>
      {gradePercents.map(({ type, value }) => (
        <BarWrapper basis={value}>
          <Bar color={colorMap[type]} />
          <Percent color={colorMap[type]}>{`${value}%`}</Percent>
        </BarWrapper>
      ))}
    </Wrapper>
  );
};
